import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils.js";
const buttonVariants = cva("group/button inline-flex shrink-0 items-center cursor-pointer justify-center border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
    variants: {
        design: {
            default: "rounded-lg",
            rounded: "rounded-full",
        },
        variant: {
            primary: "bg-payleo-orange-500 text-white hover:bg-primary-foreground",
            accent: "bg-accent text-accent-foreground hover:bg-accent/80",
            subtle: "bg-payleo-gray-100/20 border hover:border-payleo-gray-200 text-payleo-gray-900 hover:bg-payleo-gray-200/30",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
            // ghost: "hover:bg-accent hover:text-accent-foreground",
            ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
            destructive: "bg-destructive/80 text-white hover:bg-destructive focus-visible:ring-destructive/80 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
            // NOTE: should update this to use primary color instead.
            // The payleo design system needs work
            link: "text-payleo-orange-500 underline-offset-4 hover:underline",
            green: "bg-green-600 text-white hover:bg-green-700/90 focus-visible:ring-green-600/20",
            outline: "border border-input bg-background hover:bg-accent/20 hover:border-accent-foreground/30 hover:text-accent-foreground",
            dark: "bg-payleo-gray-600 text-payleo-white hover:bg-payleo-gray",
            white: "bg-white border border-gray-200 text-payleo-gray hover:bg-payleo-white",
        },
        size: {
            default: "h-9 gap-1.5 px-3 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
            xs: "h-6 gap-1 px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
            sm: "h-8 gap-1 px-2.5 py-1.5 font-normal text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
            lg: "h-10 gap-1.5 px-4 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
            icon: "size-8",
            "icon-xs": "size-7 in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
            "icon-sm": "size-8 in-data-[slot=button-group]:rounded-lg",
            "icon-lg": "size-10 px-3",
        },
    },
    defaultVariants: {
        variant: "subtle",
        size: "default",
        design: "default",
    },
});
function Button({ className, design, variant, size, ...props }) {
    return (<ButtonPrimitive data-slot="button" {...props} className={cn(buttonVariants({ variant, size, className, design }))}/>);
}
function LinkButton({ className, design, variant, size, href, ...props }) {
    return (<a data-slot="button" href={href} {...props} className={cn(buttonVariants({ variant, size, className, design }))}/>);
}
export { Button, buttonVariants, LinkButton };
